module.exports = __webpack_public_path__ + "static/media/hair-3.d24f9a93.svg";